module.exports = __webpack_public_path__ + "static/media/aragon-logo-mark.e0b76cf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/aragon-logo-mark.svg
// module id = 166
// module chunks = 0